import { render, staticRenderFns } from "./PackageFiltersConsumer.vue?vue&type=template&id=3077da82&"
import script from "./PackageFiltersConsumer.vue?vue&type=script&lang=js&"
export * from "./PackageFiltersConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports